import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CountryService {
  constructor(private http: HttpClient) {}

  getCountries(): Observable<any> {
    const countrycodes: string = 'assets/countrycodes.json';
    return this.http.get(countrycodes);
  }
}
